
const modules = {
	'header.main-header':                 () => import('./components/header'),
	'section.blog':                       () => import('./components/blog'),
	'a[href^="tel:"]':                    () => import('./components/tel'),
	'section.cards-element':              () => import('./elements/cards'),
	'section.faq-element':                () => import('./elements/faq'),
	'section.form-element__form':         () => import('./elements/form'),
	'section.gallery-element':            () => import('./elements/gallery'),
	'section.offers-element':             () => import('./elements/offers'),
	'section.section-reviews':            () => import('./elements/reviews'),
	'section.rooms-element':              () => import('./elements/rooms'),
	'section.subscribe-form-element':     () => import('./elements/subscribe-form'),
	'section.things-to-do-element':       () => import('./elements/things-to-do'),
	'section.property-intro-element':    () => import('./elements/property-intro'),
};

const observer = new IntersectionObserver(entries => {
	entries.forEach(entry => {
		if (!entry.isIntersecting) {
			return;
		}
		for (const [selector, load] of Object.entries(modules)) {
			if (entry.target.matches(selector)) {
				load().then(m => new m.default(entry.target));
				observer.unobserve(entry.target);
				break;
			}
		}
	});
}, {rootMargin: '200px'});

document.querySelectorAll(Object.keys(modules).join(',')).forEach(el => observer.observe(el));
